(() => {
  const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const animateSlideCopy = (slide) => {
    if (!slide) return;
    const copy = slide.querySelector('.slide__content .group-block-content');
    if (!copy) return;

    const items = Array.from(copy.children);
    items.forEach((item, index) => {
      item.getAnimations().forEach((animation) => animation.cancel());
      if (prefersReducedMotion()) {
        item.style.opacity = '1';
        item.style.transform = 'none';
        return;
      }

      item.animate(
        [
          { opacity: 0, transform: 'translate3d(0, 32px, 0)' },
          { opacity: 1, transform: 'translate3d(0, 0, 0)' }
        ],
        {
          duration: 1200,
          delay: 180 + index * 220,
          easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
          fill: 'both'
        }
      );
    });
  };

  const startSlideshowFade = () => {
    const main = document.querySelector('#MainContent');
    const slideshow = main?.querySelector('slideshow-component');
    if (!slideshow || slideshow.dataset.guvrwfFadeReady === 'true') return;
    slideshow.dataset.guvrwfFadeReady = 'true';

    let activeSlide = null;
    const refresh = () => {
      const nextActive = slideshow.querySelector("slideshow-slide[aria-hidden='false']");
      if (nextActive && nextActive !== activeSlide) {
        activeSlide = nextActive;
        animateSlideCopy(activeSlide);
      }
    };

    refresh();
    new MutationObserver(refresh).observe(slideshow, {
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startSlideshowFade, { once: true });
  } else {
    startSlideshowFade();
  }
})();
